var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGnbUse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_606_31245)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.25 32H8.75C8.34 32 8 31.66 8 31.25C8 30.84 8.34 30.5 8.75 30.5H31.25C31.66 30.5 32 30.84 32 31.25C32 31.66 31.66 32 31.25 32Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5 9.5C21.5 8.67157 20.8284 8 20 8C19.1716 8 18.5 8.67157 18.5 9.5V27.5C18.5 28.3284 19.1716 29 20 29C20.8284 29 21.5 28.3284 21.5 27.5V9.5Z",
    fill: "#2B64F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 20.5C15.5 19.6716 14.8284 19 14 19C13.1716 19 12.5 19.6716 12.5 20.5V27.5C12.5 28.3284 13.1716 29 14 29C14.8284 29 15.5 28.3284 15.5 27.5V20.5Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5 16.5C27.5 15.6716 26.8284 15 26 15C25.1716 15 24.5 15.6716 24.5 16.5V27.5C24.5 28.3284 25.1716 29 26 29C26.8284 29 27.5 28.3284 27.5 27.5V16.5Z",
    fill: "#373737"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_606_31245"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGnbUse);
export default __webpack_public_path__ + "static/media/gnb_use.9f469ab9dcb668466d5dd97ef6823d9e.svg";
export { ForwardRef as ReactComponent };